const initSemiconductorIndustryBlock = async () => {
    const setupBlock = async () => {
        const container = document.querySelector('.semiconductor_industry_accordion-block');
        if (!container) return;

        const { isMobileDevice } = await import('../lib/utils/window-utils');
        const textBlocks = container.querySelectorAll('.semiconductor_industry__card-block');
        textBlocks.forEach(block => {
            const content = block.querySelector('p');
            if (!content) return;

            block.classList.add('show');
            const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
            const lines = content.clientHeight / lineHeight;
            block.classList.remove('show');

            if (lines >= 6) {
                block.classList.add('truncated');

                if (!block.querySelector('.semiconductor_industry__toggle-icon')) {
                    const iconSpan = document.createElement('span');
                    iconSpan.classList.add('semiconductor_industry__toggle-icon');
                    const container = block.querySelector('div');
                    container?.appendChild(iconSpan);
                }
            }

            const toggle = () => block.classList.toggle('show');
            const icon = block.querySelector('.semiconductor_industry__toggle-icon');

            if (!icon) return;

            if (isMobileDevice()) {
                icon.addEventListener('touchstart', toggle);
            } else {
                icon.addEventListener('click', toggle);
            }
        });
    };

    const container = document.querySelector('.semiconductor_industry_accordion-block');
    if (container) {
        setupBlock();
        return;
    }

    const observer = new MutationObserver((mutations, obs) => {
        if (document.querySelector('.semiconductor_industry_accordion-block')) {
            obs.disconnect();
            setupBlock();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};

document.addEventListener("DOMContentLoaded", initSemiconductorIndustryBlock);
